import React from 'react'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { sortCategories } from '..'
import { buildModelUrl } from '@corratech/pylot-utils'
import { useStoreConfig, ModelTypeEnum } from 'config'
import type { CategoryTree } from '@pylot-data/pylotschema'
import s from '@commonStyles/menus/SubCategoryList.module.scss'

type SubCategoryListProps = {
    item: CategoryTree
    maxItems?: number
    isOpen?: boolean
    setIsOpen?: (newIsOpen: boolean) => void
}

export const SubCategoryList = ({
    isOpen,
    setIsOpen,
    item,
    maxItems = 10
}: SubCategoryListProps): JSX.Element | null => {
    const { t } = useTranslation()
    const children = item.children!
    const config = useStoreConfig()
    const getUrlPath = ({ url_path, external_url }: CategoryTree) => {
        return external_url || url_path
            ? buildModelUrl(
                  ModelTypeEnum.CATEGORY,
                  (external_url || url_path)!,
                  config,
                  false
              )
            : ''
    }

    children.sort(sortCategories)

    return children.length > 0 ? (
        <div className={s['subcategory']}>
            <div className={s['subcat-items']}>
                <ul>
                    {children &&
                        children.slice(0, maxItems).map((subcategory) =>
                            subcategory ? (
                                <li
                                    key={subcategory.url_path}
                                    onClick={() =>
                                        setIsOpen && setIsOpen(!isOpen)
                                    }
                                    aria-hidden="true"
                                >
                                    <Link href={getUrlPath(subcategory)}>
                                        {subcategory.name}
                                    </Link>
                                </li>
                            ) : (
                                ''
                            )
                        )}
                    <li
                        onClick={() => setIsOpen && setIsOpen(!isOpen)}
                        aria-hidden="true"
                    >
                        <Link href={getUrlPath(item)}>
                            {t('auth|Shop All')}
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    ) : null
}
